import {
    type DeleteNewsResponseType,
    type DeleteNewsRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteNews = async (params: DeleteNewsRequestType): Promise<DeleteNewsResponseType> => {
    return await request<DeleteNewsResponseType>("/news/deleteNews", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteNews;
